import type { IconData } from '@stacksjs/iconify-core'

export const viewQuilt: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 64v384h480V64Zm448 176H192V96h272Zm-272 32h120v144H192ZM48 96h112v320H48Zm296 320V272h120v144Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default viewQuilt
